import _ from 'lodash'
import wAxios from '@/plugins/w/axios/models/axios'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'
import { useAuthStore } from '@/plugins/w/auth/store/auth.store'

export interface LisRequestsFilters {
	search?: string
	date_sent?: string
	created_from?: string
	created_to?: string
	printed?: boolean
	states?: string[]
}

export const QUERY_KEY = 'requests'

export const DEFAULT_FILTERS: LisRequestsFilters = {
	search: '',
	date_sent: '',
	created_from: '',
	created_to: '',
	printed: undefined,
	states: []
}

export const fetchFn = async (pagination: Pagination, filters: LisRequestsFilters = {}) => {
	const query = fetchQuery(pagination, filters)
	// const params = buildQueryFilters(query)

	return wAxios.post_auth(`v2/requests?`,query).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: LisRequestsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
        page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || '',
		created_from: '',
		created_to: '',
		states: filtersWithDefaults.states || [],
		printed: filtersWithDefaults.printed === true ? false : undefined,
		accesses: [useAuthStore().getCurrentAccess?.id]
	}

	if (query.printed === undefined) {
		delete query.printed
	}

	if (filtersWithDefaults.date_sent && filtersWithDefaults.date_sent !== '') {
		query.created_from = filtersWithDefaults.date_sent
		query.created_to = filtersWithDefaults.date_sent
	} else if (filtersWithDefaults.created_from && filtersWithDefaults.created_to && filtersWithDefaults.created_from !== '' && filtersWithDefaults.created_to !== '') {
		query.created_from = filtersWithDefaults.created_from
		query.created_to = filtersWithDefaults.created_to
	} else {
		delete query.created_from
		delete query.created_to
	}

	return query
}

export const useGetLisRequests = createApiHook(fetchFn, QUERY_KEY, fetchQuery)
